<template>
  <crud-base
    :title="title"
    :popup-data="popupData"
    :show-popup="showPopup"
    @cancel="returnToList()"
    @add-register="save"
    @ok="popupData.type === 'error' ? (showPopup = false) : returnToList()"
  >
    <template v-slot:form>
      <div class="flex-auto lg:px-2 py-2 pt-4">
        <form>
          <div class="flex flex-wrap">
            <div class="w-full lg:w-6/12 px-2 mb-4">
              <label
                class="w-full block text-blueGray-600 text-xs font-bold mb-2"
              >
                {{ $t("forms.encuesta.title") }}
              </label>
              <encuesta-multiselect
                v-model="selectedEncuesta"
                :is-only-view="isOnlyView"
                @change="onEncuestaChange"
              />
            </div>
            <div class="w-full lg:w-6/12 px-2 mb-4">
              <label
                class="w-full block text-blueGray-600 text-xs font-bold mb-2"
              >
                {{ $t("forms.seccion.title") }}
              </label>
              <seccion-multiselect
                v-model="selectedSeccion"
                :is-only-view="isOnlyView"
                :show-btn="false"
                :encuesta-id="selectedEncuesta ? selectedEncuesta.id : null"
              />
            </div>
            <div class="w-full px-2 mb-4">
              <label
                v-if="selectedSeccion"
                class="w-full block text-blueGray-600 text-xs font-bold mb-2"
              >
                {{ $t("forms.pregunta.title") }}
              </label>
              <multiselect-preguntas
                v-model="selectedPregunta"
                :seccion-id="selectedSeccion ? selectedSeccion.id : null"
              />
            </div>
            <div class="w-full px-2 mb-4">
              <label
                class="block text-blueGray-600 text-xs font-bold mb-2"
                for="comentario"
              >
                {{ $t("forms.comentarioPregunta.title") }}
              </label>
              <textarea
                type="text"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                rows="4"
                v-model="comentario"
              />
            </div>
          </div>
        </form>
      </div>
    </template>
  </crud-base>
</template>

<script>
import CrudBase from "@/components/Cards/CrudBase.vue";
import EncuestaMultiselect from "@/views/encuestas/EncuestaMultiselect.vue";
import SeccionMultiselect from "@/views/secciones/SeccionMultiselect.vue";
import MultiselectPreguntas from "@/components/Encuestas/MultiselectPreguntas.vue";
import { baseMixin } from "@/mixins/base";
import { mapActions } from "vuex";

export default {
  components: {
    CrudBase,
    EncuestaMultiselect,
    SeccionMultiselect,
    MultiselectPreguntas,
  },
  data() {
    return {
      module: "comentario_pregunta",
      title: "Comentario de la Pregunta",
      listName: "ListComentariosPreguntas",
      popupData: {},
      showPopup: false,
      selectedEncuesta: null,
      selectedSeccion: null,
      selectedPregunta: null,
      comentario: "",
      encuestas: [],
    };
  },
  mixins: [baseMixin],
  async created() {
    this.isLoading = true;
    this.setShowOverlay(true);
    this.$router.replace({ query: {} });
    await this.fetchEncuestas();

    this.$route.params.id ? await this.loadData() : null;

    this.setShowOverlay(false);
    this.isLoading = false;
  },
  methods: {
    ...mapActions([
      "getEncuestaList",
      "setEncuestaList",
      "getEncuestaById",
      "saveComentarioPregunta",
      "getComentarioPreguntaById",
      "setShowOverlay",
      "getSeccionList",
      "setSeccionList",
      "getSeccionById",
      "getPreguntaById"
    ]),
    async loadData() {
      const res = await this.getComentarioPreguntaById({
        id: this.$route.params.id,
      });
      const data = await res.json();

      this.comentario = data?.comentario;

      const selectedEncuesta = await this.getEncuestaById({ id: data.encuesta });
      this.selectedEncuesta = selectedEncuesta;

      await this.findSeccionList();

      this.selectedSeccion = await this.getSeccionById({ id: data?.seccion });
      this.selectedPregunta = await this.getPreguntaById({ id: data?.pregunta });

      this.$router.push({
        query: {
          ...this.$route.query,
          encuesta: selectedEncuesta?.id,
          seccion: this.selectedSeccion ? this.selectedSeccion.id : null,
          pregunta: this.selectedPregunta ? this.selectedPregunta.id : null,
        },
      });
    },
    async fetchEncuestas() {
      const res = await this.getEncuestaList({ search: null, page: 1 });
      const { results } = await res.json();

      this.encuestas = results;
      this.setEncuestaList(results);
    },
    async onEncuestaChange() {
      this.selectedSeccion = null;
      this.$router.push({
        query: {
          ...this.$route.query,
          encuesta: this.selectedEncuesta.id,
        },
      });
      await this.findSeccionList();
    },
    async findSeccionList() {
      const res = await this.getSeccionList({
        params: { encuestaId: this.selectedEncuesta.id },
        pageSize: 300,
      });
      const { results } = await res.json();

      this.setSeccionList(results);
    },
    async onSeccionChange() {
      this.$router.push({
        query: {
          ...this.$route.query,
          seccion: this.selectedSeccion.id,
        },
      });
      this.selectedPregunta = null;
    },
    async save() {
      const payload = {
        encuesta: this.selectedEncuesta?.id,
        seccion: this.selectedSeccion?.id,
        pregunta: this.selectedPregunta?.id,
        comentario: this.comentario,
      };

      if (this.$route.params.id) {
        payload.id = this.$route.params.id;
      }

      this.setShowOverlay(true);
      try {
        const res = await this.saveComentarioPregunta(payload);
        this.popupData = {
          show: true,
          type: res.status >= 200 && res.status < 300 ? "success" : "error",
          title:
            res.status >= 200 && res.status < 300
              ? this.$t("popup.success.title")
              : this.$t("popup.error.title"),
          message:
            res.status >= 200 && res.status < 300
              ? this.$t("popup.success.message")
              : (await res.json()).non_field_errors[0],
        };
        this.showPopup = true;
      } catch (error) {
        this.popupData = {
          show: true,
          type: "error",
          title: this.$t("popup.error.title"),
          message: this.$t("popup.error.message"),
        };
        this.showPopup = true;
      } finally {
        this.setShowOverlay(false);
      }
    },
  },
  watch: {
    selectedEncuesta(newVal) {
      if (newVal && !this.isLoading) {
        this.onEncuestaChange();
      }
    },
    selectedSeccion(newVal) {
      if (newVal && !this.isLoading) {
        this.onSeccionChange();
      }
    },
  },
};
</script>
